
    import './styles.scoped.css';
    export default {
  "runtime-content-wrapper": "awsui_runtime-content-wrapper_14m8x_spfr5_5",
  "runtime-header-wrapper": "awsui_runtime-header-wrapper_14m8x_spfr5_9"
};
  